import { render, staticRenderFns } from "./MobileFormManager.vue?vue&type=template&id=11280cda&scoped=true&"
import script from "./MobileFormManager.vue?vue&type=script&lang=js&"
export * from "./MobileFormManager.vue?vue&type=script&lang=js&"
import style0 from "./MobileFormManager.vue?vue&type=style&index=0&id=11280cda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11280cda",
  null
  
)

export default component.exports